export let coinsJson = {
    "ETH": "https://dynamic-assets.coinbase.com/dbb4b4983bde81309ddab83eb598358eb44375b930b94687ebe38bc22e52c3b2125258ffb8477a5ef22e33d6bd72e32a506c391caa13af64c00e46613c3e5806/asset_icons/4113b082d21cc5fab17fc8f2d19fb996165bcce635e6900f7fc2d57c4ef33ae9.png",
    "BTC": "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
    // "BSC": "https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png",
    // "MATIC": "https://s2.coinmarketcap.com/static/img/coins/64x64/3890.png",
    "SOL": "https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png",
    "TRX": "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png",
    "XRP": "https://s2.coinmarketcap.com/static/img/coins/64x64/52.png"
}
